import {Swiper, SwiperSlide} from 'swiper/react';
import {Pagination, Autoplay} from 'swiper/modules'
import {useSelector} from 'react-redux';
import Selector from '../../../selectors/pages/main/balance';
import Tasks from './task';
import Cashback from './cashback';
import 'swiper/css';

export default () => {
    const {wallet} = useSelector(Selector);

    if(wallet.redflag)
        return <></>;

    return (
        <div className="slider">
            <Swiper 
                modules={[Pagination, Autoplay]}
                pagination={{
                    el: '.dots',
                    clickable: true,
                    renderBullet: (index, className) => {
                        return `<div class="dot ${className}" data-index="${index}"></div>`
                    }
                }}
                autoplay={{
                    delay: 5e3
                }}
                speed={500}
                slidesPerGroup={1}
                slidesPerView={1}>
                <SwiperSlide><Cashback /></SwiperSlide>
                <SwiperSlide><Tasks /></SwiperSlide>
            </Swiper>

            <div className="dots">

            </div>
        </div>
    )
}